import React, { useMemo, useState } from 'react';
import TopHeader from '../components/TopHeader/TopHeader';
import Footer from '../components/Footer/Footer';
import SearchPosts from '../components/Search/Search';
import SEO from '../components/SEO/SEO';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import { Container, List } from 'semantic-ui-react';
import * as helpers from '../utility/helpers';
import { Tags } from '../components/Tags/Tags';
import 'semantic-ui-less/semantic.less';
import '../style.css';
import { useEffect } from 'react';

const BlogMeta = () => (
    <Helmet>
        <title>Blog | Yahia Bakour</title>
    </Helmet>
);

const Blog = ({ data }) => {
    const posts = data.allMarkdownRemark.edges;
    const displayPosts = useMemo(() => helpers.getDisplayPosts(posts), [posts]);
    const [resultPosts, setResultPosts] = useState(displayPosts);

    useEffect(() => {
        if (resultPosts.length === 0) {
            setResultPosts(displayPosts);
        }
    }, [resultPosts]);

    return (
        <Container text>
            <BlogMeta />
            <SEO />
            <TopHeader />
            <div className="blog-header-container">
                <h1>A mixture of inspired analysis and incoherent rambling.</h1>
                <h2>Enjoy your time, stay a while.</h2>
            </div>
            <SearchPosts posts={displayPosts} center={true} setResults={setResultPosts} />
            <List selection>
                {resultPosts.map((post) => (
                    <List.Item href={post.slug}>
                        <List.Content floated="right">
                            <Tags tags={post.tags} />
                        </List.Content>
                        <List.Header>{post.title}</List.Header>
                    </List.Item>
                ))}
            </List>
            <Footer />
        </Container>
    );
};

export const pageQuery = graphql`
    query BlogQuery {
        allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
            edges {
                node {
                    id
                    fields {
                        slug
                    }
                    frontmatter {
                        date(formatString: "MMMM DD, YYYY")
                        title
                        tags
                    }
                }
            }
        }
    }
`;

export default Blog;
